var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_169_5903)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4166 1H3.58334C2.70886 1 2 1.76111 2 2.7V13.75C2 14.6889 2.70886 15.45 3.58334 15.45H19.4166C20.2911 15.45 21 14.6889 21 13.75V2.7C21 1.76111 20.2911 1 19.4166 1ZM8.33334 16.3C7.8961 16.3 7.54166 16.6805 7.54166 17.15C7.54166 17.6195 7.8961 18 8.33334 18H14.6666C15.1039 18 15.4584 17.6195 15.4584 17.15C15.4584 16.6805 15.1039 16.3 14.6666 16.3H8.33334Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_169_5903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 17,
    fill: "white",
    transform: "translate(2 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopIconSmall);
export default __webpack_public_path__ + "static/media/DesktopIconSmall.ebff5a3a12c8f5b32385df6194a26efd.svg";
export { ForwardRef as ReactComponent };